import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { DefaultErrorComponent } from '@/components/shared/default-error-component'

export const router = createRouter({
  routeTree,
  defaultErrorComponent: DefaultErrorComponent,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
